import { Box, alpha } from '@mui/material';
import React from 'react';
import { CaptionText } from '../typography/PrimaryTypography';

interface ColorTagProps {
  text: string;
  color: string;
  icon?: React.ReactElement;
}

/**
 * Reusable component for highlighted text in a tag styled element.
 * @param {string} text Text to display in the tag.
 * @param {string} color Color of text and faded color to use for background.
 * @param {SVGElement | undefined} icon Optionally provide an icon to show at the start of the tag.
 * @returns {JSX.Element}
 */
const ColorTag = ({ text, color, icon }: ColorTagProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        alignItems: 'center',
        justifyContent: 'center',
        py: icon ? 1 : 0.5,
        px: 2,
        borderRadius: 2,
        backgroundColor: alpha(color, 0.2),
        color: color
      }}
    >
      {icon && icon}
      <CaptionText sx={{ color: color }}>{text}</CaptionText>
    </Box>
  );
};

export default ColorTag;
